@if (loadingItem() !== null) {
  <div aria-live="assertive" class="spinner-container" role="alert">
    <div class="spinner-overlay"></div>
    <app-spinner-circle
      [position]="CssPositionEnum.RELATIVE"
      [size]="'3.125rem'"
      aria-label="Ładowanie"
    ></app-spinner-circle>
    @if (hasContent()) {
      <div class="spinner-content">
        @if (hasTitle()) {
          <h2>{{ loadingItem().title }}</h2>
        }
        @if (hasDescription()) {
          <p>{{ loadingItem().description }}</p>
        }
      </div>
    }
  </div>
}

